import axios from 'axios'

var newDate = new Date().toISOString().slice(0, 10).split('-')
var yearNow = parseInt(newDate[0])
if (yearNow <= 2500) { yearNow = yearNow + 543 }
let hostAPI = "./connectAPI/api_ibd.php?API="

const funcs = {
  sendIBDCARD(sendPID, sendLaserPID, sendFname, sendLname, sendBirthDate) {
    let sendAPI = hostAPI + '/CheckCardByLaser?pid=' + sendPID + '&FirstName=' + sendFname + '&LastName=' + sendLname + '&BirthDay=' + sendBirthDate + '&Laser=' + sendLaserPID
    // console.log('sendAPI', sendAPI)
    return new Promise((resolve, reject) => {
      axios.get(sendAPI)
        .then(function (response) {
          // console.log('response',response.data.Desc)
          let resData = response.data.Desc
          resolve(resData)
        })
        .catch(function (error) {
          resolve(error.response.status)
          reject(error)
          // console.log('error', error.response.data.info)
        })
    })
  }
}
export default funcs
